import {
  EVENT_NAME,
  EventProps,
  PRODUCT_AREA,
  SUB_PRODUCT_AREA,
} from '@leagueplatform/analytics';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { useIntl } from '@leagueplatform/locales';
import { HeaderNavLink } from '@leagueplatform/solutions-foundation';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { ANALYTICS_DETAILS, SUB_PRODUCT_AREA_NAMES } from 'common/constants';

type AnalyticsPayload = HeaderNavLink['analyticsPayload'];

const getNavLinksAnalyticsPayload = (
  payload: EventProps,
): AnalyticsPayload => ({
  eventName: EVENT_NAME.BUTTON_CLICKED,
  eventProps: {
    product_area: PRODUCT_AREA.GET_CARE,
    ...payload,
  },
});

export const useNavLinksList = () => {
  const { formatMessage } = useIntl();
  const navLinksList: HeaderNavLink[] = [
    {
      to: APP_MANAGED_ROUTES.HOME,
      label: formatMessage({ id: 'STR_HOME' }),
      icon: 'homeNavIcon',
      analyticsPayload: getNavLinksAnalyticsPayload({
        sub_product_area: SUB_PRODUCT_AREA.HOMESCREEN,
        detail: ANALYTICS_DETAILS.HEADER_NAVIGATE_TO_HOME,
        screen_name: formatMessage({ id: 'STR_HOME' }),
      }),
    },
    {
      to: APP_MANAGED_ROUTES.APPOINTMENTS,
      label: formatMessage({ id: 'STR_APPOINTMENTS' }),
      icon: 'appointmentsNavIcon',
      analyticsPayload: getNavLinksAnalyticsPayload({
        sub_product_area: SUB_PRODUCT_AREA_NAMES.APPOINTMENT,
        detail: ANALYTICS_DETAILS.HEADER_NAVIGATE_TO_APPOINTMENTS,
        screen_name: formatMessage({ id: 'STR_APPOINTMENTS' }),
      }),
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.careDocuments),
      label: formatMessage({ id: 'STR_DOCUMENTS' }),
      icon: 'documentsNavIcon',
      analyticsPayload: getNavLinksAnalyticsPayload({
        sub_product_area: SUB_PRODUCT_AREA.DOCUMENTS,
        detail: ANALYTICS_DETAILS.HEADER_NAVIGATE_TO_DOCUMENTS,
        screen_name: formatMessage({ id: 'STR_DOCUMENTS' }),
      }),
    },
    {
      to: getModulePath(LEAGUE_MODULE_NAMES.healthJourney),
      label: formatMessage({ id: 'STR_JOURNEY' }),
      icon: 'journeyNavIcon',
      analyticsPayload: getNavLinksAnalyticsPayload({
        sub_product_area: SUB_PRODUCT_AREA_NAMES.HEALTH_JOURNEY,
        detail: ANALYTICS_DETAILS.HEADER_NAVIGATE_TO_JOURNEY,
        screen_name: formatMessage({ id: 'STR_JOURNEY' }),
      }),
    },
  ];
  return {
    navLinks: navLinksList,
  };
};
